/**
 * Resolves the affiliate code the current widget session is attributed to.
 * Prefers the data-affiliate attribute on the root div (set by the partner
 * embed snippet or the showFireknifeReservation arg), falling back to
 * ?affiliate= for the direct widget link case. Returns undefined when absent
 * or malformed.
 *
 * Shared by the booking submit (Step4) and the price display (useCart) so the
 * shown price is gated on the same affiliate's contract that the booking is
 * attributed to.
 */
export function resolveAffiliateCode(): string | undefined {
    const root = document.getElementById('fireknife-widget-root');
    const fromAttr = root?.getAttribute('data-affiliate');
    const fromUrl = new URLSearchParams(window.location.search).get('affiliate');
    const candidate = fromAttr || fromUrl;
    return candidate && /^[a-zA-Z0-9_-]{1,64}$/.test(candidate) ? candidate : undefined;
}
